import BaseVue from '@/base/BaseVue';
import {Options} from 'vue-class-component';

// @ts-ignore
@Options({})
export default class Jifenduihuan extends BaseVue {

  list: any = {
    list: [],
    pageNum: 0,
    pageSize: 0,
    pages: 0,
    size: 0,
    total: 0,
  };

  search: any = {
    nickName: null,
    openId: null,
    hangban: null,
    date: null,
    address: null,
    name: null,
    status: null,
    pi: 1,
    ps: 10
  };

  selectList = [];


  mounted() {
    this.getList(1);
  }

  gotoImg(img: string) {
    window.open(img);
  }

  getList(pi: number) {
    this.search.pi = pi;
    console.log(this.search);
    this.http.getJiFenDuiHuanList(this.search).then(res => {
      this.list = res.data;
    }).catch(res => {
      this.toast_warn(res.msg);
    });
  }

  onReset() {
    this.search = {
      name: null,
      pi: 1,
      ps: 10
    };
    this.getList(1);
  }


  changeStatus(item: any, status: number) {
    this.http.shenheJifenDuiHuan({id: [item.id], status: status}).then(res => {
      this.getList(1);
      this.selectList = [];
      this.toast_success(res.msg);
    }).catch(res => {
      this.toast_warn(res.msg);
    });
  }

  yijianChangeStatus(status: number) {
    this.http.shenheJifenDuiHuan({
      id: this.selectList.map((res: any) => {
        return res.id;
      }), status: status
    }).then(res => {
      this.getList(1);
      this.selectList = [];
      this.toast_success(res.msg);
    }).catch(res => {
      this.toast_warn(res.msg);
    });
  }

  handleSelectionChange(val: any) {
    this.selectList = val;
  }

}
